
//below function determines whether the portal should connect to local server or production server
//for testing and development purpose, it is recommended to use local server

export const getLocationOrigin = () => {
   //local server
  //  return "http://localhost:8000/api/v1";

   //production server
   return "https://api.sporthood.in/api/v1";
};


export const checkStatus = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  let body = null;
  try {
    body = await response.json();
  } catch (e) {
    // non-JSON error body, fall back to statusText below
  }

  const error = new Error((body && (body.message || body.detail)) || response.statusText);
  error.response = response;
  error.status = response.status;
  error.body = body;
  // Present on both @ratelimit (Retry-After header only) and @backoff
  // (header + retry_after_seconds in the body) responses.
  const retryAfterHeader = response.headers.get('Retry-After');
  error.retryAfter = retryAfterHeader ? Number(retryAfterHeader) : (body && body.retry_after_seconds) || null;
  return Promise.reject(error);
};

export const parseJSON = (response) => {
  return response.json();
};

export const defaultOptions = {
  credentials: 'include'
};


export async function postData(url, data = {}) {
  var custom_url = `${getLocationOrigin() + url}`;
  const response = await fetch(custom_url, {
    method: 'POST',
    mode: 'cors', 
    cache: 'no-cache', 
    credentials: 'include', 
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data) 
  })
  .then(checkStatus)
  .then(parseJSON)
  return response
}



export async function getData(url) {
  var custom_url = `${getLocationOrigin() + url}`;
  const options = {...defaultOptions};
  const response = await fetch(custom_url,options)
  .then(checkStatus)
  .then(parseJSON)
  return response
}